/**
 *  parsley-config.js
 *  Custom validators or global hooks for Parsley form validation.
 *  parsleyjs.org
 */

// Validation regex strings for unicode
var unicodeLetter = '[a-zA-Z\\u0080-\\u00FF\\u0100-\\u017F\\u0180-\\u024F\\u0250-\\u02AF\\u0300-\\u036F\\u0370-\\u03FF\\u0400-\\u04FF\\u0500-\\u052F\\u0530-\\u058F\\u0590-\\u05FF\\u0600-\\u06FF\\u0700-\\u074F\\u0750-\\u077F\\u0780-\\u07BF\\u07C0-\\u07FF\\u0900-\\u097F\\u0980-\\u09FF\\u0A00-\\u0A7F\\u0A80-\\u0AFF\\u0B00-\\u0B7F\\u0B80-\\u0BFF\\u0C00-\\u0C7F\\u0C80-\\u0CFF\\u0D00-\\u0D7F\\u0D80-\\u0DFF\\u0E00-\\u0E7F\\u0E80-\\u0EFF\\u0F00-\\u0FFF\\u1000-\\u109F\\u10A0-\\u10FF\\u1100-\\u11FF\\u1200-\\u137F\\u1380-\\u139F\\u13A0-\\u13FF\\u1400-\\u167F\\u1680-\\u169F\\u16A0-\\u16FF\\u1700-\\u171F\\u1720-\\u173F\\u1740-\\u175F\\u1760-\\u177F\\u1780-\\u17FF\\u1800-\\u18AF\\u1900-\\u194F\\u1950-\\u197F\\u1980-\\u19DF\\u19E0-\\u19FF\\u1A00-\\u1A1F\\u1B00-\\u1B7F\\u1D00-\\u1D7F\\u1D80-\\u1DBF\\u1DC0-\\u1DFF\\u1E00-\\u1EFF\\u1F00-\\u1FFF\\u20D0-\\u20FF\\u2100-\\u214F\\u2C00-\\u2C5F\\u2C60-\\u2C7F\\u2C80-\\u2CFF\\u2D00-\\u2D2F\\u2D30-\\u2D7F\\u2D80-\\u2DDF\\u2F00-\\u2FDF\\u2FF0-\\u2FFF\\u3040-\\u309F\\u30A0-\\u30FF\\u3100-\\u312F\\u3130-\\u318F\\u3190-\\u319F\\u31C0-\\u31EF\\u31F0-\\u31FF\\u3200-\\u32FF\\u3300-\\u33FF\\u3400-\\u4DBF\\u4DC0-\\u4DFF\\u4E00-\\u9FFF\\uA000-\\uA48F\\uA490-\\uA4CF\\uA700-\\uA71F\\uA800-\\uA82F\\uA840-\\uA87F\\uAC00-\\uD7AF\\uF900-\\uFAFF',
    unicodeText = unicodeLetter + "\\-\\_\\s\\']*";
    unicodeTextAndNumber = unicodeLetter + "0-9\\-\\_\\s]*";
    internationalCharacters = /^[ a-zA-Z0-9@#$&(),\+\!\-\'\.\/\"\_]*$/;

window.Parsley.addValidator('unicodeText', {
  validateString: function(value) {
    return new RegExp(unicodeText).test(value);
  }
});

window.Parsley.addValidator('unicodeTextNumber', {
  validateString: function(value) {
    return new RegExp(unicodeTextAndNumber).test(value);
  }
});

/**
* Validator to check international characters only if the property is not in synxis.
**/
window.Parsley.addValidator('synxisProperty', {
  validateString: function(value) {
    // Check if property is in synxis system. If not, ensure no unsupported characters are passed.
    if(typeof pdata !== 'undefined' && pdata.synxis === false) {
      return internationalCharacters.test(value);;
    } else {
      // In case flag is not found always return true.
      return true;
    }
  }
});

// Email address validator - unicode edition
window.Parsley.addValidator('emailAddress', {
  validateString: function(value) {
    var emailAddressRegex = /^(?!\.)((?!.*\.{2})[a-zA-Z0-9\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u20D0-\u20FF\u2100-\u214F\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2F00-\u2FDF\u2FF0-\u2FFF\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uF900-\uFAFF\.!#$%&'*+-/=?^_`{|}~\-\d]+)@(?!\.)([a-zA-Z0-9\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u20D0-\u20FF\u2100-\u214F\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2F00-\u2FDF\u2FF0-\u2FFF\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uF900-\uFAFF\-\.\d]+)((\.([a-zA-Z\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u20D0-\u20FF\u2100-\u214F\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2F00-\u2FDF\u2FF0-\u2FFF\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uF900-\uFAFF]){2,63})+)$/;
    return emailAddressRegex.test(value);
  }
})

// Postal code validator
window.Parsley.addValidator('postalCode', {
  validateString: function(value) {
    var country = $('.country select').val();
    switch (country) {
      case 'US':
        return /^\d{5}([-]{0,1}\d{4})?$/i.test(value);
        break;
      case 'CA':
        return /^[abceghjklmnprstvxyABCEGHJKLMNPRSTVXY]{1}\d{1}[a-zA-Z]{1} *\d{1}[a-zA-Z]{1}\d{1}$/i.test(value);
        break;
      case 'GB':
        return /^([A-PR-UWYZ](([0-9](([0-9]|[A-HJKSTUW])?)?)|([A-HK-Y][0-9]([0-9]|[ABEHMNPRVWXY])?))[ ]?[0-9][ABD-HJLNP-UW-Z]{2})/i.test(value);
        break;
      default:
        return /^[A-Za-z0-9-\s]+$/.test(value);
        break;
    }
  }
});

// Validate 2 fields equal, ignore character casing.
window.Parsley.addValidator('equalsIgnoreCase', {
  requirementType: 'string',
  validateString: function(value, requirement) {
    var requirementFieldVal = $(requirement).val();
    return value.toUpperCase() === requirementFieldVal.toUpperCase();
  }
});

// Validate 3 fields don't have the same value, ignore character casing
window.Parsley.addValidator('threeWayCompare', {
  requirementType: 'string',
  validateString: function(value, requirement) {
    // Split list of selectors
    var array = requirement.split(',');

    var an1 = $(array[0]).val();
    var an2 = $(array[1]).val();

    // validate against first field if it's not null
    if (an1 != null) {
      if (value.toUpperCase() === an1.toUpperCase()) {
        // console.log("answers cannot be the same");
        return false;
      }
    }

    // validate against second field if it's not null
    if (an2 != null) {
      if (value.toUpperCase() === an2.toUpperCase()) {
        // console.log("answers cannot be the same");
        return false;
      }
    }

  }
});

// Validate answers are or alpha numeric and can include periods or dashes
window.Parsley.addValidator('allowedAnswerCharacters', {
  requirementType: 'string',
  validateString: function(value) {
    return /^[a-zA-Z0-9 .-]+$/.test(value);
  },
  messages: {
    en: 'Answers cannot contain any special characters (periods and dashes are ok)'
  }
});

// Handle mm/dd/yyyy, dd/mm/yyyy, and yyyy/mm/dd date formats depending on locale
window.Parsley.addValidator('date', {
  requirementType: 'string',
  validateString: function(value) {
    var dateRegex = window.localeDateFormat.regex || /(0[1-9]|1[012])[- \/.](0[1-9]|[12][0-9]|3[01])[- \/.](19|20)\d\d/;

    return dateRegex.test(value);
  }
});

function getElTrueHeight(el) {
  if (el.length > 0) {
    return Math.ceil(
      Math.ceil(el.height() * 1) + Math.ceil(getCSSPropertyAsInt(el, 'padding-top') * 1) + Math.ceil(getCSSPropertyAsInt(
        el, 'padding-bottom') * 1) + Math.ceil(getCSSPropertyAsInt(el, 'margin-top') * 1) + Math.ceil(getCSSPropertyAsInt(
        el, 'margin-bottom') * 1) + Math.ceil(getCSSPropertyAsInt(el, 'border-top-width') * 1) + Math.ceil(
        getCSSPropertyAsInt(el, 'border-bottom-width') * 1)
    );
  }

  return 0;
}
function getCSSPropertyAsInt(el, property) {
  var num = (el.css(property).replace(/px/, ''));
  num = (num.replace(/%/, ''));
  num *= 1;

  return (!(isNaN(num))) ? num : 0;
}


// Scroll to top of form on invalid form.
window.Parsley.on( 'form:validate', function (form) {
  if (!form.isValid() && !form.$element.is('#wr-signin') && form.$element.parents('.modal-content').length <= 0) {
    for (var n = 0; n < form.fields.length; n++) {
      if (form.fields[n].validationResult !== true) {
        $("html,body").animate({
          scrollTop: $(form.fields[n].$element[0]).offset().top - $('#pageHeader, header[role=banner]:visible').outerHeight() - getElTrueHeight($('#bookingBar__main'))
        });

        break;
      }
    }
    // Close the AR list if there is an parsley error
    if (form.$element.is('.booking-bar-form.booking-bar-main')) {
      setTimeout( function() {
        form.$element.find('.destination.ui-autocomplete-input.parsley-error').blur();
        $('.destination.ui-autocomplete-input.parsley-error').one('focusin', function (){
          $('form.booking-bar-form').parsley().reset();
        });
      }, 200);
    }
  }

  // Scroll to first invalid field for security question setup
  if (!form.isValid() && form.$element.is('#set-security-answers') ) {
    for (var n = 0; n < form.fields.length; n++) {
      if (form.fields[n].validationResult !== true) {
        $('#wr-login .modal-dialog').scrollTop(0);
        var iosOffsetHeight = $('#wr-login .modal-dialog').offset().top;
        $("#wr-login .modal-dialog").animate({
          scrollTop: $(form.fields[n].$element[0]).offset().top - iosOffsetHeight - 30
        }, 200);

        break;
      }
    }
  }

});

// Add aria attributes to invalid form fields for accessibility.
window.Parsley.on( 'field:error', function() {
  var self = this;
  this.$element.attr({
    'aria-describedby': self._ui.errorsWrapperId,
    'aria-invalid': true
  });
}).on( 'field:success', function() {
  this.$element.attr('aria-invalid', false).removeAttr('aria-describedby');
});
